import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NgxQrcodeStylingComponent } from 'ngx-qrcode-styling';
import { environment } from '../../../../environments/environment';
import { MatchExtended, MatchState } from '../../shared/model/match';
import { OpenSquashService } from '../../shared/services/open-squash-service';
import { CreatePlayerComponent } from '../create-player-component/create-player-component';
import { Player } from '../../shared/model/player';

@Component({
  selector: 'app-set-order-player-final-component',
  imports: [CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
  ],
  templateUrl: './set-order-player-final-component.html',
  styleUrl: './set-order-player-final-component.scss'
})
export class SetOrderPlayerFinalComponent {
public data = inject(MAT_DIALOG_DATA);
  private dialogRef = inject(MatDialogRef<CreatePlayerComponent>);
  private fb = inject(FormBuilder);

  private openSquashService = inject(OpenSquashService);
  match!: MatchExtended;
  config: any; // Configuración del QR

  ngOnInit() {
    this.match = { ...this.data.match };  
  }

  form: FormGroup = this.fb.group({
    player: ['', Validators.required],
  });

  submit() {
    if (this.form.valid) {
      // this.openSquashService.setFinalPlayer(this.data.category, this.data.match, this.form.value.player).subscribe(() => {
      //   this.dialogRef.close(true);
      // });
    }
  }

  exit() {
    this.dialogRef.close(null);
  }
}

